export { default } from './CollapseNavigation';
